import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';

type BottomNavItem = {
  label: string;
  icon: string;
  route: string;
  match: (url: string) => boolean;
};

@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <nav class="bottom-nav" aria-label="Mobile navigation">
      <a
        *ngFor="let item of items"
        [routerLink]="item.route"
        [class.active]="item.match(currentUrl)"
        [attr.aria-current]="item.match(currentUrl) ? 'page' : null"
      >
        <span class="nav-icon" aria-hidden="true">{{ item.icon }}</span>
        <span>{{ item.label }}</span>
      </a>
    </nav>
  `,
  styles: [
    `
      .bottom-nav {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 60;
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 4px;
        padding: 7px 8px calc(7px + env(safe-area-inset-bottom));
        border-top: 1px solid var(--topbar-line);
        background: rgba(7, 9, 20, 0.86);
        backdrop-filter: blur(20px);
        box-shadow: 0 -18px 42px rgba(0, 0, 0, 0.34);
      }

      a {
        min-width: 0;
        min-height: 48px;
        border-radius: 14px;
        color: var(--muted);
        display: grid;
        place-items: center;
        align-content: center;
        gap: 2px;
        font-size: 11px;
        font-weight: 900;
        line-height: 1;
      }

      .nav-icon {
        font-size: 17px;
        line-height: 1;
      }

      a.active {
        color: var(--nav-active);
        background: linear-gradient(135deg, color-mix(in srgb, var(--red) 32%, transparent), color-mix(in srgb, var(--blue) 32%, transparent));
        box-shadow: inset 0 0 0 1px var(--line-strong);
      }

      @media (min-width: 768px) {
        .bottom-nav {
          display: none;
        }
      }
    `,
  ],
})
export class BottomNavComponent {
  currentUrl = this.router.url;
  items: BottomNavItem[] = [
    { label: 'Search', icon: '🔎', route: '/', match: (url) => url === '/' },
    { label: 'Movies', icon: '🎬', route: '/movies', match: (url) => url.startsWith('/movies') },
    { label: 'Cinemas', icon: '📍', route: '/cinemas', match: (url) => url.startsWith('/cinemas') },
    { label: 'Admin', icon: '⚙', route: '/admin/scrape', match: (url) => url.startsWith('/admin') },
  ];

  constructor(private readonly router: Router) {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      this.currentUrl = event.urlAfterRedirects;
    });
  }
}
